<template>
  <div v-if="!loading" class="contacts-page row">
    <div class="left-wrap medium-12">
      <div class="cards-container">
        <survey-card :header="survey.name">
          <div class="survey-info">
            <span class="description">{{ survey.description }}</span>
          </div>
        </survey-card>
        <div class="cards-row">
          <survey-card :header="$t('SURVEY_MGMT.SURVEY.TABLE.RESPONSES')">
            <span class="average-rating">
              {{ survey.responses.length }}
            </span>
          </survey-card>
          <survey-card :header="$t('SURVEY_MGMT.SURVEY.TABLE.AVERAGE')">
            <span :class="['average-rating', getHeaderColor()]">
              {{ averageRating().response }}
            </span>
          </survey-card>
          <survey-card :header="$t('SURVEY_MGMT.SURVEY.TABLE.PROMOTER')">
            <span class="average-rating">
              {{ promotersCount() }}
            </span>
          </survey-card>
          <survey-card :header="$t('SURVEY_MGMT.SURVEY.TABLE.NEUTRE')">
            <span class="average-rating">
              {{ neutralCount() }}
            </span>
          </survey-card>
          <survey-card :header="$t('SURVEY_MGMT.SURVEY.TABLE.DETRACTOR')">
            <span class="average-rating">
              {{ detractorsCount() }}
            </span>
          </survey-card>
        </div>
        <survey-card header="Respostas">
          <div class="response-list">
            <div
              v-for="response in survey.responses"
              :key="response.id"
              class="response-row"
            >
              <div :class="['rating-indicator', getRatingColor(response)]" />
              <div class="information">
                <p class="rating-value">{{ getRating(response).response }}</p>
                <p class="response-name">{{ getName(response) }}</p>
              </div>
              <div class="actions">
                <p>{{ formatTimestamp(response.updated_at) }}</p>
                <woot-button
                  v-tooltip="$t('SURVEY_MGMT.SURVEY.TABLE.BUTTONS.VIEW')"
                  icon="eye-show"
                  variant="smooth"
                  size="small"
                  @click="openSurveyModel(response)"
                />
                <woot-button
                  v-tooltip="$t('SURVEY_MGMT.SURVEY.TABLE.BUTTONS.DELETE')"
                  icon="delete"
                  variant="smooth"
                  size="small"
                  @click="openDeleteTable(response)"
                />
              </div>
            </div>
          </div>
          <woot-button class="download-button" @click="downloadSurveyReport">
          {{ $t('SURVEY_MGMT.SURVEY.TABLE.BUTTONS.DOWNLOAD') }}
        </woot-button>
        </survey-card>
        <vue-word-cloud
            class="word-cloud"
            style="height: 480px; width: 640px;"
            :words="wordCloudData"
            spacing="0.5"
            :color="
              ([, weight]) =>
                weight > 10 ? '#005057' : weight > 5 ? '#018b98' : '#01c7d9'
            "
            font-family="Roboto"
          >
            <template slot-scope="{ text, weight, originalWord }">
              <div
                :title="`${text}: ${weight}`"
                @click="onWordClick(originalWord)"
              >
                {{ text }}
              </div>
            </template>
          </vue-word-cloud>
      </div>
      <woot-modal
        :show.sync="showSurveyModel"
        :on-close="closeSurveyModel"
        size="medium"
      >
        <survey-info :edit-model="selectedModel" @on-close="closeSurveyModel" />
      </woot-modal>
      <woot-modal
        :show.sync="showDeleteTablePopup"
        :on-close="closeDeleteGroup"
      >
        <woot-confirm-delete-modal
          v-if="showDeleteTablePopup"
          :show.sync="showDeleteTablePopup"
          :title="$t('SURVEY_MGMT.MODELS.DELETE.TITLE')"
          :message="$t('SURVEY_MGMT.SURVEY.DELETE.MESSAGE')"
          :confirm-text="$t('SURVEY_MGMT.MODELS.DELETE.CONFIRM_TEXT')"
          reject-text="Cancelar"
          :confirm-value="$t('SURVEY_MGMT.MODELS.DELETE.CONFIRM_VALUE')"
          :confirm-place-holder-text="
            $t('SURVEY_MGMT.MODELS.DELETE.PLACEHOLDER')
          "
          @on-confirm="confirmTableDeletion"
          @on-close="closeDeleteGroup"
        />
      </woot-modal>
    </div>
  </div>
  <div v-else class="loading">Carregando...</div>
</template>

<script>
import { mapGetters } from 'vuex';
import { downloadCsvFile } from '../../../../helper/downloadHelper';

import ModelHeader from './Header';
import alertMixin from 'shared/mixins/alertMixin';
import NewModel from './NewModel.vue';
import EditModel from './EditModel.vue';
import ModelCard from '../../../../components/ui/ModelCard.vue';
import SurveyByModel from './SurveyByModel.vue';
import SurveyCard from './SurveyCard.vue';
import SurveyInfo from './SurveyInfo.vue';
import VueWordCloud from 'vuewordcloud';

export default {
  components: {
    ModelHeader,
    NewModel,
    EditModel,
    ModelCard,
    SurveyByModel,
    SurveyInfo,
    SurveyCard,
    SurveyCard,
    VueWordCloud,
  },
  mixins: [alertMixin],

  data() {
    return {
      columns: [],
      kanbanId: 0,
      showAddModel: false,
      showSurveyModel: false,
      loading: true,
      showDeleteTablePopup: false,
      rating_type: null,
      responseToDelete: null,
      kanbanMeta: {},
      heading: 'Teste',
      content: 'content',
      src: 'src',
      buttonText: 'Selecionar Modelo',
      selectedModel: null,
      wordCloudData: [],
    };
  },

  computed: {
    ...mapGetters({
      currentUser: 'getCurrentUser',
      accountId: 'getCurrentAccountId',
      kanbanList: 'getKanbanfunnels',
      currentAccountId: 'getCurrentAccountId',
      getAccount: 'accounts/getAccount',
      getSurvey: 'customSurveys/getSurvey',
    }),
    pageTitle() {
      return this.$t('SURVEY_MGMT.MODELS.HEADER');
    },
  },

  watch: {},
  async mounted() {
    await this.$store.dispatch('customSurveys/getSurvey');
    this.$store.dispatch('agents/get');
    this.getSurveyInfo();
  },
  methods: {
    closeDeleteGroup() {
      this.showDeleteTablePopup = false;
    },
    openDeleteTable(model) {
      this.responseToDelete = model;
      this.showDeleteTablePopup = true;
    },
    async deleteTable(id) {
      try {
        this.loading = true;
        await this.$store.dispatch('customSurveys/deleteResponse', {
          id: id,
        });
        this.showAlert(this.$t('SURVEY_MGMT.SURVEY.DELETE.SUCCESS_MESSAGE'));
        await this.getSurveyInfo();
        this.loading = false;
      } catch (error) {
        const errorMessage =
          error?.response?.message ||
          this.$t('SURVEY_MGMT.SURVEY.DELETE.ERROR_MESSAGE');
        console.log(error);
        this.showAlert(errorMessage);
      }
    },
    confirmTableDeletion() {
      this.deleteTable(this.responseToDelete.id);
      this.responseToDelete = null;
      this.closeDeleteGroup();
    },
    formatTimestamp(timestamp) {
      const date = new Date(timestamp);

      const months = [
        'jan',
        'fev',
        'mar',
        'abr',
        'mai',
        'jun',
        'jul',
        'ago',
        'set',
        'out',
        'nov',
        'dez',
      ];

      const day = date.getDate();
      const month = months[date.getMonth()];
      const year = date.getFullYear();

      const hours = String(date.getHours()).padStart(2, '0');
      const minutes = String(date.getMinutes()).padStart(2, '0');
      const seconds = String(date.getSeconds()).padStart(2, '0');

      return `${day} de ${month} de ${year} ${hours}:${minutes}:${seconds}`;
    },
    getName(param) {
      const firstValidText = param.questions.find(
        q => q.type === 'text' && q.response
      );

      if (firstValidText) {
        return firstValidText.response;
      }
    },
    getRating(param) {
      const firstValidRatingA = param.questions.find(
        q => q.type === 'rating_a' && q.response
      );
      const firstValidRating =
        !firstValidRatingA &&
        param.questions.find(q => q.type === 'rating' && q.response);

      if (firstValidRatingA) {
        return {
          response: firstValidRatingA.response,
          type: firstValidRatingA.type,
        };
      }
      if (firstValidRating) {
        return {
          response: firstValidRating.response,
          type: firstValidRating.type,
        };
      }
      return null;
    },
    detractorsCount() {
      if (this.survey.responses) {
        const validRatingsCount = this.survey.responses.reduce(
          (count, response) => {
            const ratingA = response.questions.find(
              q => q.type === 'rating_a' && q.response < 7
            );

            const rating =
              !ratingA &&
              response.questions.find(
                q =>
                  q.type === 'rating' &&
                  q.required === true &&
                  (q.response === 1 || q.response === 2)
              );

            return count + (ratingA || rating ? 1 : 0);
          },
          0
        );

        return validRatingsCount;
      }
      return '0';
    },
    averageRating() {
      if (this.survey.responses) {
        const averageRating = this.survey.responses.reduce(
          (acc, response) => {
            const ratingA = response.questions.find(q => q.type === 'rating_a');

            const rating =
              !ratingA && response.questions.find(q => q.type === 'rating');

            const validRating = ratingA
              ? ratingA.response
              : rating
              ? rating.response
              : null;

            if (validRating !== null) {
              acc.sum += validRating;
              acc.count += 1;
              acc.type = rating ? 'rating' : 'rating_a';
            }

            return acc;
          },
          { sum: 0, count: 0 }
        );

        const average =
          averageRating.count > 0
            ? (averageRating.sum / averageRating.count).toFixed(2)
            : '0';

        return { response: average, type: averageRating.type };
      }
      return '0';
    },
    neutralCount() {
      if (this.survey.responses) {
        const validRatingsCount = this.survey.responses.reduce(
          (count, response) => {
            const ratingA = response.questions.find(
              q =>
                q.type === 'rating_a' && (q.response === 7 || q.response === 8)
            );

            const rating =
              !ratingA &&
              response.questions.find(
                q =>
                  q.type === 'rating' && q.required === true && q.response === 3
              );

            return count + (ratingA || rating ? 1 : 0);
          },
          0
        );

        return validRatingsCount;
      }
      return '0';
    },
    promotersCount() {
      if (this.survey.responses) {
        const validRatingsCount = this.survey.responses.reduce(
          (count, response) => {
            const ratingA = response.questions.find(
              q =>
                q.type === 'rating_a' && (q.response === 9 || q.response === 10)
            );

            const rating =
              !ratingA &&
              response.questions.find(
                q =>
                  q.type === 'rating' && (q.response === 4 || q.response === 5)
              );
            return (
              count + (ratingA !== undefined || rating !== undefined ? 1 : 0)
            );
          },
          0
        );

        return validRatingsCount;
      }
      return '0';
    },
    async getSurveyInfo() {
      const pageURL = window.location.href;
      this.survey = await this.getSurvey(
        pageURL.substring(pageURL.lastIndexOf('/') + 1)
      );
      this.generateWordCloudData();
      this.loading = false;
    },
    generateWordCloudData() {
      const wordCounts = {};
      this.survey.responses.forEach(response => {
        response.questions.forEach(question => {
          if (question.type === 'text' && question.response) {
            const words = question.response.split(/\s+/);
            words.forEach(word => {
              word = word.toLowerCase();
              if (wordCounts[word]) {
                wordCounts[word]++;
              } else {
                wordCounts[word] = 1;
              }
            });
          }
        });
      });

      this.wordCloudData = Object.entries(wordCounts).map(([word, count]) => [
        word,
        count,
      ]);
    },
    getRatingColor(response) {
      const rating = this.getRating(response).response;
      const type = this.getRating(response).type;
      if (type === 'rating_a') {
        if (rating <= 6) return 'red';
        if (rating > 6 && rating < 9) return 'yellow';
        if (rating >= 9) return 'green';
        return 'gray';
      }
      if (rating <= 2) return 'red';
      if (rating > 2 && rating < 4) return 'yellow';
      if (rating >= 4) return 'green';
      return 'gray';
    },
    getHeaderColor() {
      const rating = this.averageRating().response;
      const type = this.averageRating().type;
      if (type === 'rating_a') {
        if (rating <= 6) return 'redFont';
        if (rating > 6 && rating < 9) return 'yellowFont';
        if (rating >= 9) return 'greenFont';
        return 'gray';
      }
      if (rating <= 2) return 'redFont';
      if (rating > 2 && rating < 4) return 'yellowFont';
      if (rating >= 4) return 'greenFont';
      return 'gray';
    },
    openAddModel() {
      this.selectedModel = null;
      this.showAddModel = true;
    },
    openSurveyModel(model) {
      this.selectedModel = model;
      this.showSurveyModel = true;
    },
    closeSurveyModel() {
      this.showSurveyModel = false;
    },
    closeAddModel() {
      this.showAddModel = false;
    },
    openEditModel(model) {
      this.selectedModel = model;
      this.showAddModel = true;
    },
    logModel(model) {},
    downloadSurveyReport() {
      const survey = this.survey;
      const responses = survey.responses;
      const createdAt = new Date(survey.created_at);
      const formattedDate = createdAt.toISOString().split('T')[0];
      const fileName = `survey_report_${formattedDate}.csv`;

      let csvContent = '\uFEFF';
      csvContent += `${this.$t('SURVEY_MGMT.SURVEY.TABLE.NAME')},${this.$t(
        'SURVEY_MGMT.SURVEY.TABLE.DESCRIPTION'
      )},${this.$t('SURVEY_MGMT.SURVEY.TABLE.RESPONSES')},${this.$t(
        'SURVEY_MGMT.SURVEY.TABLE.AVERAGE'
      )},${this.$t('SURVEY_MGMT.SURVEY.TABLE.PROMOTER')},${this.$t(
        'SURVEY_MGMT.SURVEY.TABLE.NEUTRE'
      )},${this.$t('SURVEY_MGMT.SURVEY.TABLE.DETRACTOR')}\n`;
      csvContent += `${survey.name},${survey.description},${responses.length},${
        this.averageRating().response
      },${this.promotersCount()},${this.neutralCount()},${this.detractorsCount()}\n\n`;

      csvContent += `${this.$t('SURVEY_MGMT.SURVEY.TABLE.RESPONSES')}\n`;
      responses[0].questions.forEach(question => {
        csvContent += `${question.question ? question.question : ''},`;
      });
      csvContent += `\n`;
      responses.forEach(response => {
        response.questions.forEach(question => {
          csvContent += `${question.response ? question.response : ''},`;
        });
        csvContent += `\n`;
      });

      downloadCsvFile(fileName, csvContent);
    },
  },
};
</script>

<style lang="scss" scoped>
.contacts-page {
  width: 100%;
  overflow: auto;
}

.cards-container {
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  gap: 20px;
  padding: 30px;
}

.response-row {
  display: flex;
  align-items: center;
  width: 100%;
  padding: 10px;
  border-bottom: 1px solid #ccc;
}

.information {
  display: flex;
  align-items: center;
}

.response-list {
  display: flex;
  flex-direction: column;
  width: 100%;
}

.rating-indicator {
  width: 5px;
  height: 50px;
  margin-right: 10px;
}

.red {
  background-color: red;
}

.yellow {
  background-color: rgb(192, 192, 0);
}

.green {
  background-color: green;
}

.rating-value {
  min-width: 20px;
}

.redFont {
  color: red;
}

.yellowFont {
  color: rgb(192, 192, 0);
}

.word-cloud {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 auto;
}

.greenFont {
  color: green;
}

.actions {
  margin-left: auto;
  align-items: center;
  display: flex;
  gap: 10px;
}

.timestamp {
  margin-left: auto;
}

.survey-info {
  display: flex;
  flex-direction: row;
  align-items: space-between;
  justify-content: space-between;
  width: 100%;
}

.cards-row {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 20px;
}

.average-rating {
  font-size: 2.5rem;
}

.loading {
  text-align: center;
}

.left-wrap {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.download-button {
  margin-top: 20px;
  align-self: flex-end;
}
</style>
